import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRightIcon } from "lucide-react";
import { categories } from "../../data/categories";
import { CategoryId } from "../../types/ingredient";
const ease = [0.23, 1, 0.32, 1] as const;
interface CategoryExplorerProps {
  onSelect: (id: CategoryId) => void;
}
export function CategoryExplorer({
  onSelect
}: CategoryExplorerProps) {
  const [activeId, setActiveId] = useState<CategoryId>(categories[0].id);
  const active = categories.find(c => c.id === activeId) ?? categories[0];
  return <section id="ingredients" className="scroll-mt-20 bg-paper" data-id="element-55" data-mp="1nn47ueaazh3t">
      <div className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32" data-id="element-56" data-mp="1nop1m1osmw0m">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-57" data-mp="1smqn0t9oz7f9">
          <h2 className="font-display text-5xl leading-[1.02] tracking-tight text-ink md:text-6xl lg:col-span-7" data-id="element-58" data-mp="3i0dmekhphssx">
            Six familles d'ingrédients,
            <br data-id="element-59" data-mp="3mz6xk69it7px" />
            une seule origine.
          </h2>
          <p className="max-w-md text-base leading-relaxed text-stone lg:col-span-5 lg:justify-self-end" data-id="element-60" data-mp="32mj6huq5ch52">
            81 références produites sur nos terres ou chez des producteurs voisins que nous connaissons par leur
            prénom. Toutes disponibles en vrac, en format échantillon ou en développement sur-mesure.
          </p>
        </div>

        <div className="mt-16 grid gap-12 lg:grid-cols-12" data-id="element-61" data-mp="37gnemhb5ev7q">
          <ul className="lg:col-span-7" role="list" data-id="element-62" data-mp="2jpi148sokf0l">
            {categories.map(cat => {
            const isActive = cat.id === activeId;
            return <li key={cat.id} className="border-t border-line last:border-b" data-id="element-63" data-mp="2spwpjh0xya8b">
                  <button type="button" onMouseEnter={() => setActiveId(cat.id)} onFocus={() => setActiveId(cat.id)} onClick={() => onSelect(cat.id)} className="group grid w-full grid-cols-[1fr_auto] items-baseline gap-x-6 py-6 text-left focus:outline-none focus-visible:bg-cream" aria-describedby={`cat-desc-${cat.id}`} data-id="element-64" data-mp="2oo1ma6zg9mrw">
                    <span className={`font-display text-3xl transition-colors duration-150 ease-out md:text-[2.6rem] md:leading-tight ${isActive ? "text-terracotta" : "text-ink"}`} data-id="element-65" data-mp="31pb0dser0664">
                      {cat.name}
                    </span>
                    <span className="flex items-center gap-3 whitespace-nowrap text-sm text-stone" data-id="element-66" data-mp="2j0nyfirvbwwr">
                      {cat.count} références
                      <ArrowUpRightIcon className={`h-4 w-4 transition-[transform,color] duration-150 ease-out ${isActive ? "translate-x-0.5 -translate-y-0.5 text-terracotta" : ""}`} aria-hidden data-id="element-67" data-mp="2n1g6i8p07vrg" />
                    </span>
                    <span id={`cat-desc-${cat.id}`} className={`col-span-2 grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isActive ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`} data-id="element-68" data-mp="1rt5u57qfpe4i">
                      <span className="overflow-hidden" data-id="element-69" data-mp="1du63xvn9wr68">
                        <span className="block max-w-lg pt-3 text-sm leading-relaxed text-stone" data-id="element-70" data-mp="1dvpldpko189l">
                          {cat.description}
                        </span>
                      </span>
                    </span>
                  </button>
                </li>;
          })}
          </ul>

          <div className="hidden lg:col-span-5 lg:block" data-id="element-71" data-mp="v358hhld3drf">
            <div className="sticky top-28" data-id="element-72" data-mp="v4q4zcr8l6rx">
              <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-sand" data-id="element-73" data-mp="q3isx1i29lfg">
                <AnimatePresence initial={false} data-id="element-74" data-mp="l4z8j5j48hp7">
                  <motion.img key={active.id} src={active.image} alt={active.caption} initial={{
                  opacity: 0,
                  scale: 1.02
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} exit={{
                  opacity: 0
                }} transition={{
                  duration: 0.28,
                  ease
                }} className="absolute inset-0 h-full w-full object-cover" data-id="element-75" data-mp="l57mz1uvzv2i" />
                </AnimatePresence>
              </div>
              <p className="mt-4 text-sm italic text-stone" data-id="element-76" data-mp="22f5yd7u7alt5">{active.caption}</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}